import { Link, useParams } from "react-router-dom";
import ArticleBody from "../components/ArticleBody";
import { findPlatformArticle } from "../lib/platformArticles";

export default function PlatformArticlePage() {
  const { slug } = useParams();
  const article = findPlatformArticle(slug);
  if (!article) return <p>Not found.</p>;
  return (
    <div>
      <p><Link to="/">← RC Race HQ</Link></p>
      <h1>{article.title}</h1>
      <div className="card">
        <p className="muted">{article.summary}</p>
        <ArticleBody body={article.body} />
      </div>
    </div>
  );
}
